export enum APP_SAVE_BAR_SCOPE {
  ASSET_TECHNICAL_DATA_EDITOR = "asset-technical-data-editor",
  ASSET_TYPE_SEVERITY_GRID_EDITOR = "asset-type-severity-grid-editor",
  INTERVENTION_SECTION_EDITOR = "intervention-section-editor",
  INTERVENTION_TEMPLATE_JSON_EDITOR = "intervention-template-json-editor",
  TECHNICAL_FORM_EDITOR = "technical-form-editor",
}

export type AppSaveBarScope = `${APP_SAVE_BAR_SCOPE}`;
